import { priceTagFormatter } from "../../../constants/utils";

const ProductCardDetail = ({ productData }: any) => {
    return (
        <div>
            <div className="d-flex justify-content-between mt-2">
                <h2 className="fs-md-14 fs-10 fw-700">
                    {productData?.brand?.brand_name}
                </h2>
                <h2 className="fs-md-14 fs-10 fw-600">
                    {priceTagFormatter(productData?.product_srp)}
                </h2>
            </div>
          {!productData?.is_contact_lens && <div className="d-flex gap-2 justify-content-between mt-1 mb-0">
                    <h2 className='mb-0 fs-12 fw-500'>
                         {productData?.modal_number} 
                    </h2>
                <h2 className='mb-0 fs-12 fw-500'>{productData?.brand_color_code} ; {productData?.glass_size}MM </h2>
            </div>}
            {productData?.is_contact_lens && <div className="d-flex gap-1 justify-content-between mt-1 mb-1">
                    <h2 className='mb-0 fs-12 fw-500'>
                         {productData?.lens_name} 
                    </h2>
                <h2 className='mb-0 fs-12 fw-500'>{productData?.color?.color_name} </h2>
            </div>}
        </div>
    );
};

export default ProductCardDetail;
